/** UI phase for AuthGatedApp — keep loading/sign-out on landing chrome (no spinner). */
export type AuthGatePhase =
  | { kind: "landing"; staticMotion: true; content: "none" }
  | { kind: "landing"; staticMotion: false; content: "signin" }
  | { kind: "app" };

export function resolveAuthGatePhase(input: {
  isSigningOut: boolean;
  isLoading: boolean;
  isAuthenticated: boolean;
}): AuthGatePhase {
  if (input.isSigningOut || input.isLoading) {
    return { kind: "landing", staticMotion: true, content: "none" };
  }
  if (!input.isAuthenticated) {
    return { kind: "landing", staticMotion: false, content: "signin" };
  }
  return { kind: "app" };
}
